// src/HeaderDropdown.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import SeznamUzivatelu from './SeznamUzivatelu';
import JakVip from './JakVip';  // Importujeme novou komponentu
// Removed AdminPages modal; link directly to popup editor
import { useAuth } from './contexts/AuthContext';
import NotificationComposer from './components/NotificationComposer';
import NotificationDeleter from './components/NotificationDeleter';
import AdminReportsModal from './components/AdminReportsModal';
import { MdPerson, MdEdit, MdStars, MdAdminPanelSettings, MdLogout, MdPersonAdd, MdSearch, MdWeb, MdReport, MdNotifications, MdDelete, MdSettings, MdCloudUpload } from 'react-icons/md';
import FilemoonUploader from './components/FilemoonUploader';

const HeaderDropdown = ({
    isDropdownOpen,
    navigateToProfile,
    handleNicknameChange,
    openModal,
    shouldShowVIPLabel,
    userRole,
    openAddRoleModal
}) => {
    const { role } = useAuth();
    const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false);
    const [isUserListOpen, setIsUserListOpen] = useState(false);
    const [isJakVipOpen, setIsJakVipOpen] = useState(false);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isPagesOpen, setIsPagesOpen] = useState(false); // legacy (unused)
    const [isNotifOpen, setIsNotifOpen] = useState(false);
    const [isNotifDeleteOpen, setIsNotifDeleteOpen] = useState(false);
    const [isNotificationsMenuOpen, setIsNotificationsMenuOpen] = useState(false);
    const [isReportsOpen, setIsReportsOpen] = useState(false);

    // Always start with only the base menu when the header dropdown opens.
    // This ensures submenus (Admin, Nastavení, Notifikace) are closed on each fresh open.
    useEffect(() => {
        if (isDropdownOpen) {
            setIsAdminMenuOpen(false);
            setIsSettingsOpen(false);
            setIsNotificationsMenuOpen(false);
        }
    }, [isDropdownOpen]);
    const openReports = () => {
        setIsReportsOpen(true);
    };

    const handleAdminMenuToggle = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        setIsAdminMenuOpen(prev => {
            const next = !prev;
            if (next) {
                // closing other submenus when Admin menu opens
                setIsSettingsOpen(false);
                setIsNotificationsMenuOpen(false);
            }
            return next;
        });
    };

    const openPages = () => {
        window.location.href = '/admin/popups';
    };

    const handleUserListToggle = () => {
        setIsUserListOpen(true);  // Otevře modální okno
    };

    const handleCloseUserList = () => {
        setIsUserListOpen(false);
    };

    const handleJakVipToggle = () => {
        setIsJakVipOpen(prevState => !prevState);  // Otevře/uzavře modal JakVIP
    };

    return (
        <>
            <Dropdown visible={isDropdownOpen} onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                <DropdownItem onClick={navigateToProfile}><IconWrap><MdPerson size={18} /></IconWrap>Profil</DropdownItem>
                <DropdownItem onClick={(e) => { if (e && e.stopPropagation) e.stopPropagation(); const next = !isSettingsOpen; setIsSettingsOpen(next); if (next) { setIsAdminMenuOpen(false); setIsNotificationsMenuOpen(false); } }}><IconWrap><MdSettings size={18} /></IconWrap>Nastavení
                    {isSettingsOpen && (
                        <AdminDropdown>
                            <DropdownItem onClick={() => { try { setIsSettingsOpen(false); } catch {} try { handleNicknameChange(); } catch {} }}><IconWrap><MdEdit size={16} /></IconWrap>Změna přezdívky</DropdownItem>
                        </AdminDropdown>
                    )}
                </DropdownItem>
                {userRole === 'User' && (
                    <DropdownItem onClick={handleJakVipToggle}><IconWrap><MdStars size={18} /></IconWrap>Jak získat VIP?</DropdownItem>
                )}
                {userRole === 'Majitel' || userRole === 'Admin' ? (
                    <DropdownItem onClick={handleAdminMenuToggle}><IconWrap><MdAdminPanelSettings size={18} /></IconWrap>Admin menu
                        {isAdminMenuOpen && (
                            <AdminDropdown>
                                <DropdownItem onClick={openAddRoleModal}><IconWrap><MdPersonAdd size={16} /></IconWrap>Přidat roli</DropdownItem>
                                <DropdownItem onClick={() => { handleUserListToggle(); }}><IconWrap><MdSearch size={16} /></IconWrap>Hledat uživatele</DropdownItem>

                                {/* Popupy: přímý odkaz na editor popupů */}
                                <DropdownItem onClick={openPages}><IconWrap><MdWeb size={16} /></IconWrap>Popupy</DropdownItem>
                                <DropdownItem onClick={openReports}><IconWrap><MdReport size={16} /></IconWrap>Nahlášení</DropdownItem>
                                <DropdownItem onClick={(e) => { e.stopPropagation(); window.location.href = '/admin/upload'; }}><IconWrap><MdCloudUpload size={16} /></IconWrap>Nahrát</DropdownItem>
                                <DropdownItem onClick={(e) => { e.stopPropagation(); const next = !isNotificationsMenuOpen; setIsNotificationsMenuOpen(next); if (next) { setIsAdminMenuOpen(true); setIsSettingsOpen(false); } }}><IconWrap><MdNotifications size={16} /></IconWrap>Notifikace
                                    {isNotificationsMenuOpen && (
                                        <AdminDropdown onClick={(e) => e.stopPropagation()}>
                                            <DropdownItem onClick={(e) => { e.stopPropagation(); setIsNotifOpen(true); }}><IconWrap><MdNotifications size={16} /></IconWrap>Vytvořit notifikaci</DropdownItem>
                                            <DropdownItem onClick={(e) => { e.stopPropagation(); setIsNotifDeleteOpen(true); }}><IconWrap><MdDelete size={16} /></IconWrap>Smazat notifikaci</DropdownItem>
                                        </AdminDropdown>
                                    )}
                                </DropdownItem>
                            </AdminDropdown>
                        )}
                    </DropdownItem>
                ) : null}
                <DropdownItem onClick={openModal}><IconWrap><MdLogout size={18} /></IconWrap>Odhlásit se</DropdownItem>
            </Dropdown>
            {isUserListOpen && (
                <ModalOverlay>
                    <SeznamUzivatelu closePopup={handleCloseUserList} />
                </ModalOverlay>
            )}
            {isJakVipOpen && (
                <ModalOverlay>
                    <JakVip closePopup={handleJakVipToggle} />
                </ModalOverlay>
            )}

            {/* AdminPages modal removed; navigating directly to /admin/popups */}
            {isNotifOpen && (
                <NotificationComposer onClose={() => setIsNotifOpen(false)} />
            )}
            {isNotifDeleteOpen && (
                <NotificationDeleter onClose={() => setIsNotifDeleteOpen(false)} />
            )}
            {isReportsOpen && (
                <AdminReportsModal onClose={() => setIsReportsOpen(false)} />
            )}
            {/* uploader is now a full page at /admin/upload */}
        </>
    );
};

const Dropdown = styled.div`
    position: absolute;
    top: 130%;
    right: 0;
    background: #333;
    border-radius: 5px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    min-width: 250px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    opacity: ${props => props.visible ? 1 : 0};
    transform: translateY(${props => props.visible ? '0' : '-6px'});
    pointer-events: ${props => props.visible ? 'auto' : 'none'};
    transition: opacity 180ms cubic-bezier(.2,.9,.3,1), transform 180ms cubic-bezier(.2,.9,.3,1);
`;

const DropdownItem = styled.div`
    padding: 10px 15px;
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
    &:hover {
        background: ${props => props.noHoverBg ? 'transparent' : '#555'};
    }
`;

const VIPLabel = styled.div`
    background-color: #e67e22;
    color: #fff;
    border-radius: 12px;
    padding: 2px 8px;
    font-size: 12px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    height: 24px;
    white-space: nowrap;
`;

const AdminDropdown = styled.div`
    position: absolute;
    top: 10;
    right: 100%; /* Umístí dropdown nalevo od rodičovského elementu */
    background: #333;
    border-radius: 5px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
    min-width: 200px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 1001;
    transform: translateX(-10px); /* Přidá trochu mezery mezi položkami */
`;

const ModalOverlay = styled.div`
    cursor: default;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const IconWrap = styled.div`
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #cde;
    flex-shrink: 0;
`;

export default HeaderDropdown;
